import AccountMenu from './components/AccountMenu.jsx'

export const components = {
  AccountMenu,
}
